define('plugin/paid-attributes/view/AttributeListView',['require','plugin/product/view/ProductListView','plugin/paid-attributes/view/AttributeItemView','lib/view/UnwrapBehavior','Config'],function (require) {

    var ProductListView = require('plugin/product/view/ProductListView');
    var AttributeItemView = require('plugin/paid-attributes/view/AttributeItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    /**
     * Products composite view (products container)
     *
     * @class ProductListView
     */
    return ProductListView.extend({

        template: '#paid_attribute_list_view',
        childView: AttributeItemView,
        childViewContainer: '#sb_attribute_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            ProductListView.prototype.initialize.apply(this);
            if (Config.getInstance().getBooleanOption('paid_attributes_exclusive')) {
                this.listenTo(this.collection, 'change:qty', this._onExclusiveQtyChange);
            }
        },

        _onExclusiveQtyChange: function (model) {
            if (model.get('qty') > 0) {
                this.collection.each(function (item) {
                    if (item !== model && item.get('qty') > 0) {
                        item.set('qty', 0);
                    }
                });
            }
        }
    });

});
